export default "__VITE_ASSET__3446fe85__"